import React, { useState, useEffect } from 'react';

import FallbackModal from '../../popup/Fallback';

import ReplyContextMenu from '../../popup/ReplyContextMenu';
import InfoReplyUpdate from './InfoReplyUpdate';
import getNaturalTimeString, { ajaxor4, isLogon } from '../../common/basic';


export default props=>{
  if (!props.me) return <></>;
  if (!process.browser) return <></>;

  const [dDisplay, setD] = useState('none');
  const [dInfoReplyUpdate, setInfoReplyUpdate] = useState('none');
  // InfoReplyUpdate

  const [vMe, setMe] = useState(props.me);

  useEffect(() => {
    setMe(props.me);
    return ()=>{;}
  }, [props.me]);


  function updateMe(newSentence){
    // console.log("newSentence: ", newSentence);
    setMe({
      ...vMe,
      content: newSentence
    });
    ajaxor4({
      url: '/inspiration/comment/updateReply/'+props.me.id,
      data: { 'content': newSentence},
    });

  }
  return (<div className={"reply " + props.me.id +" " + (dInfoReplyUpdate == "block" ? " lack " : " ") + (props.me.seq>0 ?" rere ":" " ) }>
<style jsx>{`

.reply.lack .left, .reply.lack .center{
  opacity: .3;
}

.reply.rere{
   margin: 0 0 0 20px;
}

.psa{
    vertical-align:top;
    // padding: 5px 0 0 0;
    padding: 0;
}

.center{
  max-width: 80%;
}

.cu1{
  font-size: 14px;
  color: #343a40;
}

.cu2{
  font-size: 10px;
  color: #868e96;
}

.comment{
  font-size: 12px;
  line-height: 1.33;
  color: #343a40;
}

.right{
  float: right;
}

@media all and (max-width:606px) {
    .comment{
      width: 100%;
    }
}



`}</style>
    <div className="dib left psa">
      <a href={"/person/Blog?userid=" + (props.me.user && props.me.user.id)}>
        <img className="round-psa" src={(
          vMe.user && vMe.user.hasOwnProperty('profile_picture')
            && vMe.user.profile_picture.length > 0
            // && vMe.user.profile_picture[0].hasOwnProperty('optimized_url')
            && vMe.user.profile_picture[0].optimized_url != null
          ) ? vMe.user.profile_picture[0].optimized_url
          : "/assets/images/ico-empty.svg"}
          onError={e => {
            // console.log("onError: no PSA");
            e.target.src = "/assets/images/ico-empty.svg";
          }}
        />
        
      </a>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>
    <div className="dib center">
      <div className="dib cu1">
        <a href={"/person/Blog?userid=" + (props.me.user && props.me.user.id)}>
          {vMe && vMe.user && vMe.user.username ? vMe.user.username:'none'}</a>
      </div>&nbsp;&nbsp;&nbsp;
      <div className="dib cu2">
        {getNaturalTimeString(vMe.created_at)}
      </div>
      <div className="cl">
        <div className="dib comment">
          {vMe && vMe.content ? vMe.content:''}
        </div>
      </div>
    </div>
    {isLogon()?<div className="dib right" onClick={() => setD('block')}>
      <a><img src="/assets/images-m/more.svg" /></a>
    </div>:null}
    <FallbackModal display={dDisplay} hide={() => { setD('none') }}
      innerContent={<ReplyContextMenu me={props.me} display={dDisplay} hide={() => setD('none')} 
        onSelectAmend={() => setInfoReplyUpdate("block") }
        onSelectDelete={props.onSelectDelete}
        onSelectRERE  ={props.onSelectRERE  }
      />}
    />

      <div className="" style={{ display: dInfoReplyUpdate}} >
        <InfoReplyUpdate me={vMe} updateReply={updateMe} hide={() => setInfoReplyUpdate("none")} />
      </div>

    <div className="" style={{height: '18px'}}>&nbsp;</div>
</div>);

}
